import styled from 'styled-components';

const StyledAppContainer = styled.div`
  height: 100%;
  width: 100%;
`;

const StyledApp = styled.div`
  background: ${({ theme }) => theme.palette.background.special};
  display: flex;
  flex-direction: 'row';
  height: 100%;
  width: 100%;
`;

const StyledContentContainer = styled.div`
  display: flex;
  flex-flow: column;
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
  transition: width 0.2s ease-out;
`;

const StyledContent = styled.div`
  flex-grow: 1;
  overflow: hidden;
`;

export { StyledAppContainer, StyledApp, StyledContentContainer, StyledContent };
